/**
 * Svelte action that calls a callback when a click occurs outside the element
 * @param node - The element to watch for outside clicks
 * @param callback - Function to call when an outside click occurs
 * @returns Cleanup function
 */
export function clickOutside(node: HTMLElement, callback: () => void) {
  function handleClick(event: MouseEvent) {
    if (!node.contains(event.target as Node)) {
      callback()
    }
  }

  document.addEventListener('click', handleClick, true)

  return {
    destroy() {
      document.removeEventListener('click', handleClick, true)
    },
  }
}
